import { sortBy } from 'lodash-es';
import { useMemo } from 'react';

import { isRichTextEmpty } from 'components/form/richtext/RichTextInput';

import { DescriptionPage, DescriptionPageDto } from 'typing/endpoints';

export const useStudentSortedDescriptionPages = <T extends DescriptionPage>(
	descPagesDep?: T[],
) => {
	return useMemo(() => (descPagesDep ? sortBy(descPagesDep, 'order') : []), [
		descPagesDep,
	]);
};

const useSortedDescriptionPages = <
	T extends DescriptionPageDto | DescriptionPage
>(
	descPagesDep?: T[],
	showEmptyRequired?: boolean,
) => {
	return useMemo(
		() =>
			descPagesDep
				? sortBy(descPagesDep, 'order').filter(dp =>
						showEmptyRequired
							? (dp as DescriptionPage).isRequired
							: !isRichTextEmpty(dp.content),
				  )
				: [],
		[descPagesDep, showEmptyRequired],
	);
};

export default useSortedDescriptionPages;
